import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/Login";
import Sources from "./pages/Sources";
import Extractions from "./pages/Extractions";
import Users from "./pages/Users";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import OrgProfilePage from "./pages/OrgProfileAnalysis";
import EdgeAnalysisPage from "./pages/EdgeAnalysis";
import SourceTreePage from "./pages/SourceTree";
import SourceTreeAnalyticalPage from "./pages/SourceTreeAnalytical";
import SourceEtlConfigs from "./pages/SourceEtlConfigs";
import JobsPage from "./pages/Jobs";
import JobDetailPage from "./pages/JobDetail";
import GraphAnalysisPage from "./pages/GraphAnalysis";
import OrgRiskAnalysisPage from "./pages/OrgRiskAnalysis";


function App() {
  return (
    // The AuthProvider is now correctly inside the router's context
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/extractions" />} />
          <Route path="extractions" element={<Extractions />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="/jobs/:jobId" element={<JobDetailPage />} />
          <Route path="sources" element={<Sources />} />
          <Route
            path="sources/:sourceUuid/etl-configs"
            element={<SourceEtlConfigs />}
          />
          <Route path="users" element={<Users />} />
          <Route path="node-analysis" element={<OrgProfilePage />} />
          <Route path="edge-analysis" element={<EdgeAnalysisPage />} />
          <Route path="graph-analysis" element={<GraphAnalysisPage />} />
          <Route path="risk-analysis" element={<OrgRiskAnalysisPage />} />
          <Route path="source-tree" element={<SourceTreePage />} />
          <Route path="source-tree-analytical" element={<SourceTreeAnalyticalPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
